/**
 * Chatbot API types for backend integration
 */

// Message role enum
export enum ChatMessageRole {
    USER = "user",
    ASSISTANT = "assistant",
}

// Chat model enum
export enum ChatModel {
    GPT_4O_MINI = "gpt-4o-mini",
    GPT_4O = "gpt-4o",
    GPT_3_5_TURBO = "gpt-3.5-turbo",
}

// Single chat message
export type ChatMessage = {
    id: string;
    role: ChatMessageRole;
    content: string;
    createdAt?: string;
};

// Chat request payload
export type ChatRequest = {
    message: string;
    userId?: string;
    chatId?: string;
    chatModel?: ChatModel;
    embeddingModel?: string;
};

// Chat response for normal (non-streaming) endpoint - matches backend ChatResponseDto
export type ChatResponse = {
    response: string; // Backend uses 'response' not 'message'
    processingTime: number;
    tokenCount: number;
    sessionId?: string;
    sources?: DocumentChunk[]; // Optional document sources
};

// Stream event data matching backend StreamEventData
export type StreamEventData = {
    type: "chunk" | "token" | "done" | "error" | "ping";
    data: string;
    timestamp: number;
};

// Health check response
export type ChatbotHealthResponse = {
    status: "healthy" | "unhealthy";
    message: string;
    timestamp: string;
};

// Document chunk structure (matches backend)
export type DocumentChunk = {
    content: string;
    metadata: {
        filename: string;
        pageNumber?: number;
        chunkIndex: number;
        documentType: string;
        uploadedAt: string;
    };
    score?: number;
};

// Error response structure
export type ChatbotErrorResponse = {
    error: string;
    message: string;
    statusCode: number;
};
